/**
 * TanStack Query keys for the `/dpdp` screens.
 *
 * In a module of their own so a mutation in one component can invalidate a query another
 * component owns without importing it (BP-00 R5 keeps that traffic inside the feature,
 * and a shared key beats a shared component).
 */

/** `GET /dpdp/dsr` — the queue. */
export const DSR_QUERY_KEY = ['dpdp', 'dsr'] as const;

/** `GET /dpdp/breaches`. */
export const BREACH_QUERY_KEY = ['dpdp', 'breaches'] as const;

/** `GET /dpdp/retention`. */
export const RETENTION_QUERY_KEY = ['dpdp', 'retention'] as const;

/** `GET /dpdp/notice` — public, and the same document for both apps. */
export const NOTICE_QUERY_KEY = ['dpdp', 'notice'] as const;

/** `GET /me/erase` — the client's own request (BP-11 R17). */
export const MY_ERASURE_QUERY_KEY = ['dpdp', 'me', 'erase'] as const;
